// extracted by mini-css-extract-plugin
module.exports = {"dj-news":"news_dj-news__1IaZg","dj-news-content":"news_dj-news-content__1VE7K","enterpriseNews-swiper":"news_enterpriseNews-swiper__2KqcN"};